import React from 'react';
import { Routes,Route } from 'react-router-dom';
import IndexOne from './index/index-one';
import PrivacyPolicy from './index/privacy-policy';


function App() {
  return (
    <>
    <Routes>
      <Route path='/' element={<IndexOne/>}/>
      <Route path='/politica-privacidad' element={<PrivacyPolicy/>}/>
    </Routes>
    </>
  );
}

export default App;
